import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  FormGroup,
  Input,
  Label,
  Collapse,
} from "reactstrap"
import Select from "react-select"
import { AvForm, AvField } from "availity-reactstrap-validation"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// import "./datatables.scss"
import CustomTable from "components/Table/Table"

export const UserManagement = () => {
  // ---------------------Collapse Start-------------------------
  const [faq1, setFaq1] = useState(false)
  // ---------------------Collapse End-------------------------

  // ---------------------Modal Start-------------------------
  const [Add_User_Model, setAdd_User_Model] = useState(false)
  const [Assign_Role_Modal, setAssign_Role_Modal] = useState(false)

  const [totalSize, setTotalSize] = useState(3)

  const [selectedGroup, setselectedGroup] = useState(null)
  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup)
  }
  const optionGroup = [
    {
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
    },
  ]

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function AddUser() {
    setAdd_User_Model(!Add_User_Model)
    removeBodyCss()
  }

  function AddRole() {
    setAssign_Role_Modal(!Assign_Role_Modal)
    removeBodyCss()
  }
  // ---------------------Modal End-------------------------
  const data = {
    columns: [
      {
        text: "Name",
        dataField: "Name",
        style: { width: "41%" },
      },
      {
        text: "Mobile Number",
        dataField: "MobileNumber",
        style: { width: "41%" },
      },
      {
        text: "Status",
        dataField: "Status",
        style: { width: "18%" },
      },
    ],
    rows: [
      {
        Name: "Nilesh Soni",
        MobileNumber: "+91 9601615060",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Assign Roles"
              onClick={() => {
                AddRole()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="mdi mdi-shuffle-variant"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye" style={{ color: "red" }}></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Edit"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              onClick={() => {
                AddUser()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i className="fas fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
      {
        Name: "Nishit Kachiya",
        MobileNumber: "+91 9904045044",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Assign Roles"
              onClick={() => {
                AddRole()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="mdi mdi-shuffle-variant"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye" style={{ color: "#00ed00" }}></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Edit"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              onClick={() => {
                AddUser()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i className="fas fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
      {
        Name: "Bhargav Kondhiya",
        MobileNumber: "+91 8511428441",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Assign Roles"
              onClick={() => {
                AddRole()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="mdi mdi-shuffle-variant"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye" style={{ color: "#00ed00" }}></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Edit"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              onClick={() => {
                AddUser()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i className="fas fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
    ],
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>User Management | Matrimonial Admin</title>
        </MetaTags>
        <div className="container-fluid">
          <Row>
            <Breadcrumbs
              maintitle="Dashboard"
              title="Master"
              breadcrumbItem="User Management"
            />
            <Col sm={6}>
              <div className="float-end d-none d-md-block pt-2">
                <Button
                  color="primary"
                  className="btn btn-primary waves-effect waves-light mt-4"
                  onClick={() => {
                    AddUser()
                  }}
                  data-toggle="modal"
                  data-target=".bs-example-modal-lg"
                >
                  Add User
                </Button>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="accordion mb-3" id="accordionExample">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button font-size-15 faq"
                      style={{
                        backgroundColor: "rgb(164, 229, 207)",
                        height: "40px",
                        color: "#000",
                      }}
                      type="button"
                      onClick={() => {
                        setFaq1(!faq1)
                      }}
                    >
                      <i class="fas fa-filter"></i> &nbsp;Filter User Management
                    </button>
                  </div>
                  <Collapse isOpen={faq1} className="accordion-collapse">
                    <div className="accordion-body">
                      <Row>
                        <Col lg="4">
                          <div className="mb-3">
                            <Label>Name</Label>
                            <Input
                              type="text"
                              maxLength="25"
                              name="Name"
                              id="Name"
                            />
                          </div>
                        </Col>
                        <Col lg="4">
                          <div className="mb-3">
                            <Label>Mobile Number</Label>
                            <Input
                              type="text"
                              maxLength="25"
                              name="MobileNumber"
                              id="MobileNumber"
                            />
                          </div>
                        </Col>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label>Status</Label>
                            <Select
                              value={selectedGroup}
                              options={optionGroup}
                              classNamePrefix="select2-selection"
                            />
                          </div>
                        </Col>
                        <Col lg="1">
                          <div className="float-end d-none d-md-block pt-2">
                            <Button
                              color="primary"
                              className="btn btn-primary waves-effect waves-light mt-4"
                            >
                              Search
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Collapse>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {/* <MDBDataTable
                    responsive
                    bordered
                    paging={false}
                    searching={false}
                    data={data}
                    noBottomColumns
                  /> */}
                  <CustomTable
                    keyField="userManagement"
                    columns={data.columns}
                    data={data.rows}
                    totalSize={totalSize}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* --------------------------Add User Management Modal-------------------------- */}

      <Modal
        size="md"
        isOpen={Add_User_Model}
        toggle={() => {
          AddUser()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">
            User Management
          </h5>
          <button
            onClick={() => {
              AddUser()
            }}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <AvForm className="needs-validation">
            <Row>
              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    name="Name"
                    label="Name"
                    placeholder="Name"
                    type="text"
                    errorMessage="Enter Name"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="Name"
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    label="Mobile Number"
                    name="MobileNumber"
                    placeholder="Mobile Number"
                    type="text"
                    errorMessage="Enter Mobile Number"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="MobileNumber"
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField type="select" name="Status" label="Status">
                    <option>Active</option>
                    <option>Inactive</option>
                  </AvField>
                </FormGroup>
              </Col>
            </Row>
            <Button color="primary" className="mt-3" type="submit">
              Submit
            </Button>{" "}
            <Button
              color="outline-primary"
              className="mt-3"
              onClick={() => {
                AddUser()
              }}
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              Cancel
            </Button>
          </AvForm>
        </div>
      </Modal>

      {/* --------------------------Add Assign Role Modal-------------------------- */}

      <Modal
        size="md"
        isOpen={Assign_Role_Modal}
        toggle={() => {
          AddRole()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">
            Assign Role
          </h5>
          <button
            onClick={() => {
              AddRole()
            }}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="form-check">
            <Label className="form-check-label" htmlFor="Allow_Candidate">
              {" "}
              Allow Candidate Approval
            </Label>
            <Input
              type="checkbox"
              className="form-check-input"
              id="Allow_Candidate"
            />
          </div>
          <div class="table-responsive">
            <table class="table table-bordered mb-0 table">
              <thead>
                <tr>
                  <th>Page Name</th>
                  <th>
                    <center>View</center>
                  </th>
                  <th>
                    <center>Add/Edit</center>
                  </th>
                  <th>
                    <center>Username</center>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Dashboard</th>
                  <td>
                    <center>
                      <Input
                        type="checkbox"
                        className="form-check-input"
                        id="Dashboard_View"
                      />
                    </center>
                  </td>
                  <td>
                    <center>
                      <Input
                        type="checkbox"
                        className="form-check-input"
                        id="Dashboard_AddEdit"
                      />
                    </center>
                  </td>
                  <td>
                    <center>
                      <Input
                        type="checkbox"
                        className="form-check-input"
                        id="Dashboard_UserName"
                      />
                    </center>
                  </td>
                </tr>
                <tr>
                  <th scope="row">Candidate List</th>
                  <td>
                    <center>
                      <Input
                        type="checkbox"
                        className="form-check-input"
                        id="CandidateList_View"
                      />
                    </center>
                  </td>
                  <td>
                    <center>
                      <Input
                        type="checkbox"
                        className="form-check-input"
                        id="CandidateList_AddEdit"
                      />
                    </center>
                  </td>
                  <td>
                    <center>
                      <Input
                        type="checkbox"
                        className="form-check-input"
                        id="CandidateList_UserName"
                      />
                    </center>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  )
}
